module.exports = __webpack_public_path__ + "img/getup_des_2.a9c2e584.jpg";